import { ComputerIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Monitor = /* @__PURE__ */ createIcon(ComputerIcon, 'Monitor');
